const rules = [
    {
        field: 'franchiseIds',
        method: 'isEmpty',
        validWhen: false,
        message: 'Instance is required.'
    },
    {
        field: 'franchiseStaffId',
        method: 'isEmpty',
        validWhen: false,
        message: 'Recipients is required.'
    },
    {
        field: 'message',
        method: 'isEmpty',
        validWhen: false,
        message: 'Message is required.'
    }
];

export default rules;
